(function(angular){
	'use strict';
	
	angular
		.module('featuresModule', [
			'coreModule',
			'localStorageModule',
			'momentModule',
			'serviceLevelModule'
		])
		.value('globalConfig', globalConfig);

})(window.angular);